import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../../assign-prescriptions/images/spinner.gif';
import { IconButton, Grid, Box } from "@mui/material";
import moment from 'moment-timezone';
import { useTranslation } from "react-i18next";
import ReportsAGGrid from "../reportsGrid/reportsAGGrid";
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles(theme => ({
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none'
  },
}));

const TransactionSortObj = {
  name: { tableName: 'customers', sortColumn: 'name' },
  store: { tableName: 'accounts', sortColumn: 'name' },
  box: { tableName: 'boxes', sortColumn: 'name' },
  question: { tableName: 'qna', sortColumn: 'name' },
  answer: { tableName: '', sortColumn: 'answer' },
  submitted_on: { tableName: '', sortColumn: 'created_on' },
}

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchObject: null,
  fromdate: '',
  todate: '',
  pageNo: 0,
  pageSize: 25,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
let gridApi;

export const PopQuiz = () => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [accountValues, setAccountValues] = useState([]);
  const [boxvalues, setBoxValues] = useState([]);
  const rowsPerPage = 25;

  const { t } = useTranslation();

  useEffect(() => {
    setLoader(true);
    fetch(process.env.REACT_APP_BASEURL + "accounts", {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(accounts => {
        const storelist = accounts.map(account => {
          return { id: account.id, name: account.name };
        });

        setAccountValues(storelist);
        BindBoxesbyStoreId(storelist.map(x => x.id));
        setLoader(false);
      });
  }, []);

  const convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
  }

  //Bind Boxes by store id
  const BindBoxesbyStoreId = (store_ids) => {
    if (store_ids.length > 0) {
      setLoader(true);
      let BoxesObj = {
        store_ids: store_ids
      }
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(BoxesObj)
      })
        .then(response => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then(data => {
          const boxlist = data.map(account => {
            return { id: account.id, name: account.name };
          });
          setBoxValues(boxlist);
          setLoader(false);
        });
    }
  }

  const onGridReady = (params) => {
    gridApi = params.api
    const datasource = getServerSideDatasource(boxvalues, accountValues)
    // register datasource with the grid
    gridApi.setServerSideDatasource(datasource);
  }

  const clearFilters = () => {
    const filterModel = gridApi.getFilterModel();
    if (Object.keys(filterModel).length > 0) {
      gridApi.setFilterModel(null);
      TransactionFilterObj.searchObject = null;
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.fromdate = '';
      TransactionFilterObj.todate = '';
      gridApi.refreshServerSide();
    }
  };

  const getServerSideDatasource = (boxvalues, accountValues) => {
    return {
      getRows(params) {
        TransactionFilterObj.pageNo = Math.floor(params.request.startRow / rowsPerPage)

        const filterObject = params.request && params.request.filterModel
        const filterColumns = Object.keys(filterObject)

        // to set box_ids
        if (filterObject.box) {
          const filterValues = filterObject.box.values;
          if (filterValues.length > 0) {
            TransactionFilterObj.box_ids = boxvalues.filter(boxes => {
              return filterValues.includes(boxes.name)
            }).map(box => box.id)
          }
        } else {
          TransactionFilterObj.box_ids = []
        }

        // to set store_ids
        if (filterObject.store) {
          const filterValues = filterObject.store.values;
          TransactionFilterObj.store_ids = accountValues.filter(accounts => {
            return filterValues.includes(accounts.name)
          }).map(store => store.id)
        } else {
          TransactionFilterObj.store_ids = []
        }

        // to set fromdate and todate for stocked date
        if (filterObject.submitted_on) {
          const dateValue = filterObject.submitted_on;
          if (dateValue.operator) {
            // for date range
            if (dateValue.condition1.type === 'fromdate' && dateValue.condition2.type === 'todate') {
              const date1 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date2 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
            if (dateValue.condition2.type === 'fromdate' && dateValue.condition1.type === 'todate') {
              const date2 = moment(dateValue.condition1.dateFrom).format('YYYY-MM-DD')
              const date1 = moment(dateValue.condition2.dateFrom).format('YYYY-MM-DD')
              TransactionFilterObj.fromdate = date1
              TransactionFilterObj.todate = date2
            }
          } else {
            // for from/to date
            const date = moment(dateValue.dateFrom).format('YYYY-MM-DD')
            if (dateValue.type === 'fromdate') {
              TransactionFilterObj.fromdate = date
              TransactionFilterObj.todate = ''
            } else {
              TransactionFilterObj.todate = date
              TransactionFilterObj.fromdate = ''
            }
          }
        } else {
          TransactionFilterObj.todate = '';
          TransactionFilterObj.fromdate = ''
        }

        if (filterObject) {
          if (filterColumns.length === 0) {
            TransactionFilterObj.searchObject = null
          } else {
            TransactionFilterObj.searchObject = filterObject
          }
        }

        if (params.request.sortModel.length > 0) {
          TransactionFilterObj.tableName = TransactionSortObj[params.request.sortModel[0].colId].tableName
          TransactionFilterObj.sortColumn = TransactionSortObj[params.request.sortModel[0].colId].sortColumn
          TransactionFilterObj.sortOrder = params.request.sortModel[0].sort
        }

        const isStoreNotSelected = Boolean(filterObject.store && filterObject.store.values.length === 0)
        const isBoxNotSelected = Boolean(filterObject.box && filterObject.box.values.length === 0)

        if (isStoreNotSelected === true || isBoxNotSelected === true) {
          // store or box is not selected, so empty data
          params.successCallback([], 0);
          setData([]);
        } else {
          apiCall();
        }

        function apiCall() {
          setLoader(true);
          fetch(process.env.REACT_APP_BASEURL + 'getPopQuizReport', {
            method: 'post',
            withCredentials: true,
            headers: {
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                  .jwtToken,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(TransactionFilterObj),
          })
            .then((httpResponse) => {
              try {
                return httpResponse.json();
              } catch (error) {
                return null;
              }
            })
            .then((response) => {
              if (response && response.results) {
                if (response.results.length > 0) {
                  params.successCallback(response.results, response.total);
                  setData(response.results);
                } else {
                  params.successCallback([], 0);
                  setData([]);
                }
                setLoader(false);
              }
            })
            .catch(error => {
              setLoader(false);
              console.error(error);
              params.failCallback();
            });
        }
      }
    };
  }

  const DateCellFormatter = (params) => {
    return convertToTimeZone(params.value);
  }

  const columnDefs = [
    { field: "name", headerName: t("Report.PopQuiz.Name"), },
    {
      field: "store", headerName: t("Report.PopQuiz.Store"), filter: true,
      filterParams: {
        values: accountValues.map(account => {
          return account.name
        })
      },
      menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    },
    {
      field: "box", headerName: t("Report.PopQuiz.Location"), filter: true,
      filterParams: {
        values: boxvalues.map(box => {
          return box.name
        })
      },
      menuTabs: ['generalMenuTab', 'columnsMenuTab'],
    },
    { field: "question", headerName: t("Report.PopQuiz.Questions") },
    { field: "answer", headerName: t("Report.PopQuiz.Answers") },
    {
      field: "submitted_on", headerName: t("Report.PopQuiz.SubmittedOn"),
      cellRenderer: DateCellFormatter,
      filter: 'agDateColumnFilter',
      filterParams: {
        filterOptions: [
          {
            displayKey: 'fromdate',
            displayName: t('Report.PopQuiz.FromDate'),
            predicate: (_, cellValue) => cellValue
          },
          {
            displayKey: 'todate',
            displayName: t('Report.PopQuiz.ToDate'),
            predicate: (_, cellValue) => cellValue
          },
        ],
        maxNumConditions: 2,
      },
    },
  ]

  return (
    <Paper>
      {
        loader ?
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt="loading" />
          </div> :
          null
      }
      <Box component="div">
        <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={0} sx={{ ml: 0, mr: 1, width: '100%', border: 'solid 1px #babfc7', borderBottom: 'none' }}>
          <Grid item xs={3} md={3} sx={{ textAlign: 'end', padding: '4px 4px 4px 0' }}>
            <Tooltip key="clear-filters" title={t("Report.PopQuiz.ClearFiltersTooltip")}>
              <IconButton onClick={() => clearFilters()} style={{ backgroundColor: "#00a7e1" }}>
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Box>
      {accountValues.length && boxvalues.length ?
        <ReportsAGGrid
          columnDefs={columnDefs}
          sideBar={false}
          suppressMenuHide={true}
          rowData={data}
          defaultColDef={{
            flex: 1,
            minWidth: 150,
            floatingFilter: true,
            filter: 'agTextColumnFilter',
            filterParams: {
              filterOptions: [{
                displayKey: 'searchtext',
                displayName: 'Search Text',
                predicate: (cellValue) => cellValue
              }],
              maxNumConditions: 1,
            },
            resizable: true,
            sortable: true,
            menuTabs: ['generalMenuTab', 'columnsMenuTab'],
          }}
          onGridReady={onGridReady}
          getRowId={(params) => params.data.id}
        />
        : null
      }
    </Paper>
  );
}

PopQuiz.propTypes = {
  classes: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/reports/pop-quiz-report/index.js